import { render, staticRenderFns } from "./ClassPayStatus.vue?vue&type=template&id=cbbc9bb8&scoped=true"
import script from "./ClassPayStatus.vue?vue&type=script&lang=js"
export * from "./ClassPayStatus.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cbbc9bb8",
  null
  
)

export default component.exports